import { Component, OnInit,Input,ViewChild } from '@angular/core';
import { GetpicService } from "../getpic/getpic.service";
import { TestQueryService } from "../../test-query.service";

@Component({
  selector: 'plugins',
  templateUrl: './chile.component.html',
  styleUrls: ['./chile.component.less']
})

export class ChileComponent implements OnInit {
  // 图形参数
  @Input() value:any;
  // iframe的标签
  @ViewChild("iframe",{static:true}) iframe:any
  // 显示图形的地址
  urlss:any = "";
  // 图形的宽度
  pWidth:any = "100%";
  // 图形高度
  ifHeight:any = "100%";
  constructor(private getpic:GetpicService,public ml:TestQueryService) {
   }
  getData:any = {};
  ngOnInit(): void {}

  ngOnChanges(){
    console.log(111,this.ml.rootIp)
    this.value.newpicData['rootIp'] = this.ml.rootIp;
    this.getData = {
      refresh: this.value.refresh?this.value.refresh:-1,
      data:this.value.data,
      picheight:this.value.picheight,
      newpicData:this.value.newpicData,
      dates:this.value.dates,
      picDec: this.value.picDec,
      status:this.value.status
    };
    this.urlss = this.getpic.createGra(this.getData)
  }

}
